import { render, staticRenderFns } from "./NavigateWeb.vue?vue&type=template&id=1f6d6608&scoped=true"
import script from "./NavigateWeb.vue?vue&type=script&lang=js"
export * from "./NavigateWeb.vue?vue&type=script&lang=js"
import style0 from "./NavigateWeb.vue?vue&type=style&index=0&id=1f6d6608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d6608",
  null
  
)

export default component.exports